import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { Button } from '../../../components/Buttons';
import { Loader } from '../../../components/Loader';
import { REQUEST_INVOICES } from '../constants';
import { changeInvoiceFilter, fetchInvoices, fetchVehicleInvoices } from '../actions';
import { InvoiceSearch } from '../components/Search';
import { HBox, VBox } from '../../../components/Box';
import { selectInvoiceFilter, selectInvoices, selectItemsCount, selectPaginator } from '../selectors';
import { selectWorks } from '../../Api/selectors';
import { Dropdown } from '../../../components/Dropdown';
import { Pagination } from '../../../components/Pagination';
import { InvoiceCompanySearch } from '../components/CompanySearch';
import { InvoiceSearchRegplate } from '../components/SearchRegplate';
import { InvoiceSearchType } from '../components/SearchType';
import { InvoiceSearchCredit } from '../components/SearchCredit';
import { InvoiceSearchSynced } from '../components/SearchSynced';
import { InvoiceSearchPaid } from '../components/SearchPaid';
import { InvoiceSearchFinal } from '../components/SeacrhFinal';
import { InvoiceSearchDirection } from '../components/SearchDirection';
import { FiltersCloud } from '../components/FiltersCloud';
import { InvoicesOverviewTable } from '../components/InvoicesOverviewTable';
import { Permission } from '../../../components/Permission';
import { INVOICE_CREATE } from '../../../components/Permission/constants';
import { Modal, ModalControls } from '../../../components/Modal';
import { FormField } from '../../../components/FormFields';

import ButtonComponent from '../../../containers/App/Components/Button/Button';
import { InvoiceCreate } from './create';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import LoadingFilters from '../../../containers/App/Components/LoadingFilters/LoadingFilters';
import PaginationComponent from '../../../containers/App/Components/Pagination/Pagination';

const Container = styled.div`
  .form-controlField {
    margin-bottom: 0;
  }
`;

const TopNavbar = styled.div`
  background-color: white;
  padding: 12px 24px;
  margin: 24px 6px;
  width: 100%;
`;

const STATE = {
  currentPage: 0,
  showDefaultInvoiceCreatingPage: false,
  showProductInvoiceCreatingPage: false,
  showAdditionalForProductInvoice: false,
  showVehicleSearchForProductInvoice: false,
  showInvoicePreCreateModal: false,

  showInvoiceCreateModal: false,

  selectedType: null,
};

/* eslint-disable react/prefer-stateless-function */
class InvoicesOverviewComp extends BaseComponent {
  constructor(props) {
    super(props, STATE);
  }

  componentDidMount() {
    this.props.vehiclePage ? this.props.changeFilter('vehicle_id', this.props.vehicle?.id) : this.props.fetch();
    if (this.props.vehiclePage) {
      this.props.changeFilter('direction', null);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    ((this.props.vehiclePage && !this.props.filter?.vehicle_id) ||
      (this.props.vehiclePage && this.props.vehicle?.id != this.props.filter?.vehicle_id)) &&
      this.props.changeFilter('vehicle_id', this.props.vehicle?.id);
  }

  get invoices() {
    return this.props.invoices;
  }

  selectPage = newPage => {
    // if (newPage === this.state.currentPage) return;
    const newOffset = this.props.paginator.limit ? newPage * this.props.paginator?.limit : newPage * 50;
    this.setState({ currentPage: newPage }, this.props.changeFilter('offset', newOffset));
  };

  onDropdownChange(evt) {
    const value = evt.value;
    this.setState({ selectedType: value });
    if (value == 'product') {
      this.setState({
        showDefaultInvoiceCreatingPage: false,
        showProductInvoiceCreatingPage: true,
        showAdditionalForProductInvoice: true,
      });
    } else {
      this.setState({
        showDefaultInvoiceCreatingPage: true,
        showProductInvoiceCreatingPage: false,
        showAdditionalForProductInvoice: false,
      });
    }
  }

  onDropdownDirectionChange(evt) {
    const value = evt.value;
    this.setState({ direction: value });
  }

  handleInvoicePreCreateModal() {
    if (this.state.showDefaultInvoiceCreatingPage) {
      this.to('/invoices/create');
    } else if (this.state.showProductInvoiceCreatingPage) {
      this.to('/invoices/product/create');
      // return (<ProductInvoiceCreateModals direction={this.state.direction} vehicleId={this.selectedVehicle?.id} />)
    }
  }

  onSelectCreatingInvoiceType(type) {
    if (this.props.vehicleId) {
      if (type == 'productIncomingInvoice') {
        this.to(`/invoices/product-invoices/vehicle/${this.props.vehicleId}/product/incoming/create`);
      }

      if (type == 'productOutgoingInvoice') {
        this.to(`/invoices/product-invoices/vehicle/${this.props.vehicleId}/product/outgoing/create`);
      }

      return;
    }

    if (type == 'productIncomingInvoice') {
      return this.to('/invoices/product/incoming/create');
    }

    if (type == 'productOutgoingInvoice') {
      return this.to('/invoices/product/outgoing/create');
    }

    return this.to('/invoices/create');
  }

  onInvoicePreCreateModalClose() {
    this.setState({ showInvoicePreCreateModal: false });
  }

  onInvoiceCreateModalClose() {
    this.setState({ showInvoiceCreateModal: false });
  }

  onChangeShowSearchProductInvoice() {
    this.state.showVehicleSearchForProductInvoice === false
      ? this.setState({ showVehicleSearchForProductInvoice: true })
      : this.setState({ showVehicleSearchForProductInvoice: false });
  }

  onChangeVehicle = vehicle => {
    console.log(vehicle);
    this.setState(
      prev => ({
        ...prev,
        selectedVehicle: vehicle,
        editVehicle: false,
      }),
      () => {
        this.addInvoiceSubject('vehicle');
        this.addInvoiceSubject('BPM');
      },
    );
  };

  renderModal() {
    const typeOptions = ['product', 'vehicle/bpm/cost'].map(val => {
      return {
        label: this.lbl(`invoice.subject_type.${val}`),
        value: val,
      };
    });

    let typeValue = typeOptions.find(o => o.value == this.state.selectedType);

    return (
      <Modal title={'choose invoice type'} onClose={this.props.onClose || null}>
        <VBox>
          <FormField label={'invoice type'}>
            <Dropdown options={typeOptions} value={typeValue} onChange={this.onDropdownChange.bind(this)} />
          </FormField>
        </VBox>
        <ModalControls>
          <Button onClick={this.handleInvoicePreCreateModal.bind(this)} primary>
            {this.lbl('ok')}
          </Button>
          <Button onClick={this.onInvoicePreCreateModalClose.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  render() {
    // if (this.props.work || !this.props.filter) return <Loader small />;
    if (this.props.work || !this.props.filter) {
      return (
        <>
          <div className="container-fluid p-0">
            {/* <span style={{fontSize: '14px', fontWeight: '400', color: '#212529', lineHeight: '1.5'}}>
              {this.lbl('invoices')} ({this.props.count})
            </span> */}
            <LoadingFilters />
          </div>
        </>
      );
    }
    return (
      <Container>
        <span style={{ fontSize: '14px', fontWeight: '400', color: '#55585B', lineHeight: '1.5' }}>
          {this.lbl('invoices')} ({this.props.count})
        </span>
        <HBox stretch flip={window.innerWidth < 768}>
          <TopNavbar>
            <HBox left style={{ gap: 12, marginBottom: 12 }}>
              <div className="container-fluid p-0">
                <div className="container-fluid ps-0 pe-0 pt-2 pb-0 bg-white">
                  <div className="row p-0 m-0 align-items-center">
                    <div className="col-12 mb-3 col-lg-6 mb-3 col-xl-6 mb-3">
                      <InvoiceSearch />
                    </div>
                  </div>
                  <div className="row p-0 m-0 align-items-center">
                    <div
                      className="col-12 mb-3 col-lg-6 mb-3 col-xl-6
                     mb-3"
                    >
                      <InvoiceCompanySearch />
                    </div>
                  </div>
                </div>
              </div>

              {/*<InvoiceSearchRegplate filter={this.props.filter} />*/}
            </HBox>

            <div className="container-fluid ps-0 pe-0 pt-2 pb-0 bg-white">
              <div className="row p-0 m-0 align-items-center">
                <div className="col-12 mb-3 col-lg-6 mb-3 col-xl-6 col-xxl-3 mb-3">
                  <InvoiceSearchSynced filter={this.props.filter} />
                </div>
                <div className="col-12 mb-3 col-lg-6 mb-3 col-xl-6 col-xxl-3 mb-3">
                  <InvoiceSearchDirection filter={this.props.filter} />
                </div>
                <div className="col-12 mb-3 col-lg-6 mb-3 col-xl-6 col-xxl-3 mb-3">
                  <InvoiceSearchFinal filter={this.props.filter} />
                </div>

                <div className="col-12 mb-3 col-lg-6 mb-3 col-xl-6 col-xxl-3 mb-3">
                  <InvoiceSearchType filter={this.props.filter} />
                </div>
                <div className="col-12 mb-3 col-lg-6 mb-3 col-xl-6 col-xxl-3 mb-3">
                  <InvoiceSearchCredit filter={this.props.filter} />
                </div>
                <div className="col-12 mb-3 col-lg-6 mb-3 col-xl-6 col-xxl-3 mb-3">
                  <InvoiceSearchPaid filter={this.props.filter} />
                </div>
              </div>
            </div>

            <FiltersCloud />
          </TopNavbar>
          <TopNavbar>
            <VBox>
              <strong style={{ marginBottom: '12px' }}>{this.lbl('invoice.overview.create.title')}</strong>

              <span>{this.lbl('invoice.overview.create.type.product')}</span>
              <HBox>
                <Button
                  onClick={() => {
                    this.onSelectCreatingInvoiceType('productIncomingInvoice');
                  }}
                >
                  {this.lbl('invoice.overview.create.buyier')}
                </Button>
                <Button
                  onClick={() => {
                    this.onSelectCreatingInvoiceType('productOutgoingInvoice');
                  }}
                >
                  {this.lbl('invoice.overview.create.seller')}
                </Button>
              </HBox>
              <span>{this.lbl('invoice.overview.create.type.bpm')}</span>
              <HBox>
                <Button onClick={() => this.onSelectCreatingInvoiceType()}>
                  {this.lbl('invoice.overview.create.buyier')}
                </Button>
                <Button onClick={() => this.onSelectCreatingInvoiceType()}>
                  {this.lbl('invoice.overview.create.seller')}
                </Button>
              </HBox>
            </VBox>
          </TopNavbar>
        </HBox>

        {this.state.showInvoicePreCreateModal && this.renderModal()}
        <div>
          <InvoicesOverviewTable vehiclePage={this.props.vehiclePage} vehicleId={this.props.vehicleId} />
        </div>
        {this.props.paginator?.itemsCount > this.props.paginator?.limit && (
          <div className="d-flex justify-content-center mt-2 mb-5 mb-md-0">
            <PaginationComponent paginator={this.props.paginator} selectPage={this.selectPage} />
          </div>
        )}
      </Container>
    );
  }
  renderCreateInvoiceModal() {
    return (
      <ModalComponent
        onClose={this.onInvoiceCreateModalClose.bind(this)}
        title={<h3 className="text-muted">{this.lbl('invoice.create.title')}</h3>}
      >
        <InvoiceCreate />
      </ModalComponent>
    );
  }
}

InvoicesOverviewComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    invoices: selectInvoices(),
    paginator: selectPaginator(),
    count: selectItemsCount(),
    work: selectWorks([REQUEST_INVOICES]),
    filter: selectInvoiceFilter(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch: () => {
      dispatch(fetchInvoices());
    },
    fetchVehicleInvoices() {
      dispatch(fetchVehicleInvoices(ownProps.vehicleId));
    },
    changeFilter: (name, value) => {
      dispatch(changeInvoiceFilter(name, value));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const InvoicesOverview = compose(withConnect, withRouter)(InvoicesOverviewComp);
